export default __webpack_public_path__ + "static/media/fire_icon.ccad3683.png";